import React from "react";
import { useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as ArrowDown } from "../../svg/arrowdown.svg";
import { ReactComponent as ArrowUp } from "../../svg/arrowup.svg";

function Question({ questionText, answerText }) {
  const { container, question, answer_text, question_text, answer, icon } =
    styles;

  const [isOpen, setOpen] = useState(false);

  return (
    <div className={container}>
      <div className={question} onClick={() => setOpen((prev) => !prev)}>
        <span
          className={question_text}
          style={{
            color: isOpen
            ? "rgba(192, 192, 192, 0.87)"
            : "rgba(255, 255, 255, 0.87)",
          }}
        >
          {questionText}
        </span>
        <div className={icon}>{isOpen ? <ArrowUp /> : <ArrowDown />}</div>
      </div>
      {isOpen && (
        <div className={answer}>
          <span
            className={answer_text}
            style={{
              color: isOpen
                ? "rgba(255, 255, 255, 0.87)"
                : "rgba(192, 192, 192, 0.87)"
            }}
          >
            {answerText}
          </span>
        </div>
      )}
    </div>
  );
}

export default Question;
